import styled from 'styled-components/macro';

const MaxWidthWrapper = styled.div`
  max-width: calc(1200 / 16 * 1rem);
  padding: 0 32px;
  margin: 0 auto;
`;

export default MaxWidthWrapper;
